import Buttons from "components/UI/Button/Buttons";
import React from "react";
import "./Error404.scss";

const Error404 = () => {
	
	return (
		<div className="pageError">
			<section>
				<h5>Parace que te has perdido</h5>
				<h4>No hemos logrado encontrar la página que solicitaste</h4>
				<span>¿Quieres regresar a la página de inicio?</span>
				<Buttons redirectTo="/" onClick={null} >Inicio</Buttons>
			</section>
		</div>
	);
};

export default Error404;
